/* =====================================================
   SUED MOD × MORI YAKI — Workshop Page JS
   Assets/workshop.js
   ===================================================== */

(function(){
  // FAQ toggle
  document.querySelectorAll('.wm-faq-item').forEach(function(item){
    item.addEventListener('click', function(){
      this.classList.toggle('open');
    });
  });
  var first = document.querySelector('.wm-faq-item');
  if(first) first.classList.add('open');

  // Qty selector + Shopify ürün linkini güncelle
  var qtyEl = document.getElementById('wm-qty');
  var buyBtn = document.getElementById('wm-buy-btn');
  var productUrl = buyBtn ? buyBtn.getAttribute('data-product-url') : null;

  function updateBuyLink(){
    if(!buyBtn || !qtyEl || !productUrl) return;
    var qty = parseInt(qtyEl.textContent) || 1;
    buyBtn.setAttribute('href', productUrl + '?quantity=' + qty);
  }

  window.wmChangeQty = function(delta){
    if(!qtyEl) return;
    var v = parseInt(qtyEl.textContent) + delta;
    if(v < 1) v = 1;
    if(v > 4) v = 4;
    qtyEl.textContent = v;
    updateBuyLink();
  };

  updateBuyLink();

  // Floating CTA - scroll ile görünür/gizli
  var floatCta = document.getElementById('wm-float-cta');
  if(floatCta){
    var bookingSection = document.getElementById('wm-booking');
    var hero = document.getElementById('wm-hero');

    function updateFloatCta(){
      var heroBottom = hero ? hero.getBoundingClientRect().bottom : 400;
      var shouldShow = heroBottom < window.innerHeight * 0.5;

      if(bookingSection){
        var bookingRect = bookingSection.getBoundingClientRect();
        var bookingVisible = bookingRect.top < window.innerHeight && bookingRect.bottom > 200;
        if(bookingVisible) shouldShow = false;
      }

      floatCta.classList.toggle('visible', shouldShow);
    }

    window.addEventListener('scroll', updateFloatCta, {passive:true});
    window.addEventListener('resize', updateFloatCta);
    updateFloatCta();
  }
})();